import {
  animate,
  AnimationTriggerMetadata,
  style,
  transition,
  trigger,
} from '@angular/animations';

const defaultOptions = {
  distance: '2rem',
  duration: 200,
  easing: 'ease',
};

export const toggle = (options = {}): AnimationTriggerMetadata => {
  const { duration, easing } = { ...defaultOptions, ...options };
  return trigger('toggle', [
    transition(':enter', [
      style({ height: '0px' }),
      animate(`${duration}ms ${easing}`, style({ height: '*' })),
    ]),
    transition(':leave', [
      animate(
        `${duration}ms ${easing}`,
        style({ height: '0px', overflow: 'hidden' })
      ),
    ]),
  ]);
};

export const slideInOut = (options = {}): AnimationTriggerMetadata => {
  const { distance, duration, easing } = { ...defaultOptions, ...options };

  const timings = `${duration}ms ${easing}`;
  const targetStyle = { transform: 'translate(0, 0)', opacity: 1 };

  return trigger('slideInOut', [
    transition('void => slideFromRight', [
      style({ transform: `translate(${distance}, 0)`, opacity: 0 }),
      animate(timings),
    ]),
    transition('slideFromRight => void', [
      style(targetStyle),
      animate(
        timings,
        style({ transform: `translate(${distance}, 0)`, opacity: 0 })
      ),
    ]),

    transition('void => slideFromBottom', [
      style({ transform: `translate(0, ${distance})`, opacity: 0 }),
      animate(timings),
    ]),
    transition('slideFromBottom => void', [
      style(targetStyle),
      animate(
        timings,
        style({ transform: `translate(0, ${distance})`, opacity: 0 })
      ),
    ]),

    transition('void => slideFromTop', [
      style({ transform: `translate(0, -${distance})`, opacity: 0 }),
      animate(timings),
    ]),
    transition('slideFromTop => void', [
      style(targetStyle),
      animate(
        timings,
        style({ transform: `translate(0, -${distance})`, opacity: 0 })
      ),
    ]),
  ]);
};
